export default {
  assignment_is_saved: 'assignment Is saved',
  add_to_assignment: 'add to assignment',
  checklist: 'checklist',
  due_date: 'Due Date',
  CreateAssignment: 'Create assignment',
  EditAssignment:'EditAssignment'
}
